import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Base64 } from '@ionic-native/base64';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MomentModule } from 'ngx-moment';
import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
//Pages
import { ConfigurationPageModule } from '../pages/configuration/configuration.module';
import { DashBangkaPageModule } from '../pages/dash-bangka/dash-bangka.module';
import { DashBelitungPageModule } from '../pages/dash-belitung/dash-belitung.module';
import { DashDetailPageModule } from '../pages/dash-detail/dash-detail.module';
import { DashDuriPageModule } from '../pages/dash-duri/dash-duri.module';
import { DashLampungPageModule } from '../pages/dash-lampung/dash-lampung.module';
import { DashLombokPageModule } from '../pages/dash-lombok/dash-lombok.module';
// import { DashMedanPageModule } from '../pages/dash-medan/dash-medan.module';
import { DashTelloPageModule } from '../pages/dash-tello/dash-tello.module';
import { DashSuppaPageModule } from '../pages/dash-suppa/dash-suppa.module';
import { DashNiasPageModule } from '../pages/dash-nias/dash-nias.module';
import { DashPontianakPageModule } from '../pages/dash-pontianak/dash-pontianak.module';
import { DashboardPageModule } from '../pages/dashboard/dashboard.module';
import { LoginPage } from '../pages/login/login';
import { MonitoringPageModule } from '../pages/monitoring/monitoring.module';
import { UserPage } from '../pages/user/user';
// Providers
import { AppVersionProvider } from '../providers/app-version/app-version';
import { AuthProvider } from '../providers/auth/auth';
import { MenuProvider } from '../providers/menu/menu';
import { OPCProvider } from '../providers/opc/opc';
import { RoleProvider } from '../providers/role/role';
import { UnitProvider } from '../providers/unit/unit';
import { UserProvider } from '../providers/user/user';
import { WeatherProvider } from '../providers/weather/weather';
import { ModalAboutPage } from './../pages/modal-about/modal-about';
import { PipesModule } from './../pipes/pipes.module';
// Bootstrap
import { brightMPP } from './app.component';
import { TOKEN_NAME } from './config';


export const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: 'emq00.bright.id',
  port: 8084,
  path: '/mqtt',
  protocol: 'wss',
  clean: true,
};

const config: SocketIoConfig = {
  url: 'https://mpp.bright.id:2717',
  options: {
    path: '/stream',
  },
};

export function jwtOptionsFactory(storage) {
  return {
    tokenGetter: () => storage.get(`${TOKEN_NAME}`),
    whitelistedDomains: ['api.mpp.bright.id', 'mpp.bright.id', 'emq00.bright.id'],
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [brightMPP, LoginPage, UserPage, ModalAboutPage],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    IonicModule.forRoot(brightMPP, {
      mode: 'md',
      pageTransition: 'ios-transition',
    }),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MomentModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage],
      },
    }),
    SocketIoModule.forRoot(config),
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    PipesModule,
    DashboardPageModule,
    MonitoringPageModule,
    DashBangkaPageModule,
    DashBelitungPageModule,
    DashDuriPageModule,
    DashLampungPageModule,
    DashLombokPageModule,
    DashTelloPageModule,
    DashSuppaPageModule,
    DashNiasPageModule,
    DashDetailPageModule,
    DashPontianakPageModule,
    ConfigurationPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [brightMPP, LoginPage, UserPage, ModalAboutPage],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    StatusBar,
    SplashScreen,
    AuthProvider,
    AndroidPermissions,
    Base64,
    UserProvider,
    RoleProvider,
    MenuProvider,
    UnitProvider,
    WeatherProvider,
    AppVersionProvider,
    OPCProvider,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts